import { Delete, Down, UpDown } from 'assets/Icons'
import {
	CheckboxInput,
	DateInput,
	Label,
	NumberInput,
	NumberInputColor,
	Select,
	TextInput,
} from 'components/Form'
import { Modal } from 'components/Overlay'
import Spinner from 'components/Spinner'
import Table from 'components/Table/index'
import notification from 'helpers/notification'
import { prettyDate, prettyPrice } from 'helpers/prettyData'
import moment from 'moment'
import React, { Fragment, useEffect, useMemo, useState } from 'react'
import { useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import services from 'services/index'
import {
	DeleteStudent,
	Head,
	Header,
	InfoCard,
	Payment,
	PreviewPayment,
} from './components'
import { defaultFilter, defaultLessonForm } from './constants'
import useColorsList from './hooks/useColorsList'
import useMonthList from './hooks/useMonthList'
import useYearList from './hooks/useYearList'

const DetailGroup = () => {
	const role = useSelector(state => state?.user?.user?.user_type)

	const yearList = useYearList()
	const monthList = useMonthList()
	const colorList = useColorsList()

	const params = useParams()
	const { id } = params

	const [loading, setLoading] = useState(false)
	const [colorModal, setColorModal] = useState(false)
	const [visible, setVisible] = useState(false)
	const [visibleLesson, setVisibleLesson] = useState(false)
	const [visibleDelete, setVisibleDelete] = useState(false)

	const [disabled, setDisabled] = useState(false)
	const [disabledLesson, setDisabledLesson] = useState(false)

	const [month, setMonth] = useState(moment().format('MM'))
	const [year, setYear] = useState(moment().format('YYYY'))

	const [dataBaza, setDataBaza] = useState()
	const [colorDataBaza, setColorDataBaza] = useState([])
	const [updateDataBaza, setUpdateDataBaza] = useState()
	const [studentsDataBaza, setStudentsDataBaza] = useState([])

	const [mixedColumns, setMixedColumns] = useState([])
	const [lessonForm, setLessonForm] = useState(defaultLessonForm)
	const [deleteLessonId, setDeleteLessonId] = useState(null)

	const [search, setSearch] = useState('')
	const [bulkGrades, setBulkGrades] = useState([])
	const [filter, setFilter] = useState(defaultFilter)

	const { sort_field, sort_order } = filter

	const down = (
		<span
			className='duration-300'
			style={{
				transform: `rotate(${sort_order === 'des' ? 0 : 180}deg)`,
			}}
		>
			<Down />
		</span>
	)

	const onChangeFilter = sortField => {
		const sortOrder =
			sortField === sort_field
				? sort_order === ''
					? 'asc'
					: sort_order === 'asc'
						? 'des'
						: ''
				: 'asc'

		const newSortField = sort_order === 'des' ? '' : sortField

		const newFilter = {
			...filter,
			sort_field: newSortField,
			sort_order: sortOrder,
		}

		setFilter(newFilter)
	}

	const selectedColors = () => {
		const unique = [
			...new Map(
				bulkGrades.map(item => [
					`${item.student}-${item.lesson}`,
					item,
				])
			).values(),
		]

		setColorDataBaza(unique)
		setColorModal(true)
	}

	const bulkGradesSave = () => {
		const newData = colorDataBaza?.map(item => ({
			...item,
			color: item?.color?.value,
		}))

		const options = {
			data: newData,

			onStart: () => setLoading(true),

			onError: () =>
				notification('Error', {
					type: 'error',
				}),

			onEnd: () => setLoading(false),

			onSuccess: response => {
				if (response?.status === 201) {
					setColorDataBaza([])
					setColorModal(false)
					setBulkGrades([])

					getGroupById(id)

					notification("O'quvchilar baholandi!", {
						type: 'success',
					})
				}
			},
		}

		services.groups.createGradeWithBulk(options)
	}

	const gradeStudent = (
		student,
		lesson,
		point,
		isUpdate,
		gradeId,
		max_point
	) => {
		if (max_point < point) {
			notification(
				`Maksimal ${max_point} baho qo'ya olasiz`,
				{
					type: 'warning',
				}
			)
		} else {
			setBulkGrades(prev => [
				...prev,
				{
					student,
					point,
					lesson,
				},
			])
		}
	}

	const createLesson = () => {
		const data = {
			...lessonForm,
			group: dataBaza?.id,
		}

		const options = {
			data,

			onStart: () => setDisabledLesson(true),

			onError: () =>
				notification('Error', {
					type: 'error',
				}),

			onEnd: () => setDisabledLesson(false),

			onSuccess: response => {
				if (response?.status === 201) {
					getGroupById(id)

					setLessonForm(defaultLessonForm)

					notification(
						'Yangi dars muvaffaqiyatli yaratildi!',
						{
							type: 'success',
						}
					)

					setVisibleLesson(false)
				} else {
					notification('Error', {
						type: 'error',
					})
				}
			},
		}

		services.groups.createLessons(options)
	}

	const deleteLesson = lessonId => {
		const options = {
			id: lessonId,

			onEnd: () => setLoading(false),

			onStart: () => setLoading(true),

			onError: () =>
				notification('Error', {
					type: 'error',
				}),

			onSuccess: () => {
				getGroupById(id)

				notification("Dars o'chirildi", {
					type: 'success',
				})

				setVisibleDelete(false)
			},
		}

		services.groups.deleteLessons(options)
	}

	const uploadStudentInfo = () => {
		const options = {
			id,

			data: {
				students: updateDataBaza?.students,
			},

			onStart: () => setDisabled(true),

			onError: () =>
				notification('Error', {
					type: 'error',
				}),

			onEnd: () => setDisabled(false),

			onSuccess: response => {
				if (response?.status === 200) {
					getGroupById(id)

					notification(
						"O'quvchilar muvaffaqiyatli qo'shildi!",
						{
							type: 'success',
						}
					)

					setVisible(false)
				} else {
					notification('Error', {
						type: 'error',
					})
				}
			},
		}

		services.groups.patchStudents(options)
	}

	const headersAdmin = useMemo(() => {
		return [
			{
				key: 'order',

				label: (
					<div className='min-w-[20px] text-center sm:text-start px-[16px] py-[12px]'>
						№
					</div>
				),

				getContent: ({ index }) => {
					const order = index + 1

					return (
						<div className='text-center sm:text-start px-[16px] py-[12px]'>
							{order}
						</div>
					)
				},
			},

			{
				key: 'first_name',

				label: (
					<div className='px-[16px] py-[12px]'>
						Ism
					</div>
				),

				getContent: ({ data }) => {
					const name = data?.first_name

					return (
						<div className='text-start px-[16px] py-[12px]'>
							{name}
						</div>
					)
				},
			},

			{
				key: 'last_name',

				label: (
					<div className='px-[16px] py-[12px]'>
						Familiya
					</div>
				),

				getContent: ({ data }) => {
					const last_name = data?.last_name

					return (
						<div className='text-start px-[16px] py-[12px]'>
							{last_name}
						</div>
					)
				},
			},

			{
				key: 'phone_number',

				label: (
					<div className='px-[16px] py-[12px]'>
						Otasining telefon raqami
					</div>
				),

				getContent: ({ data }) => {
					const phone = data?.phone_number || '-'

					return (
						<div className='text-start px-[16px] py-[12px]'>
							{phone}
						</div>
					)
				},
			},

			{
				key: 'phone_number2',

				label: (
					<div className='px-[16px] py-[12px]'>
						Onasining telefon raqami
					</div>
				),

				getContent: ({ data }) => {
					const phone = data?.phone_number2 || '-'

					return (
						<div className='text-start px-[16px] py-[12px]'>
							{phone}
						</div>
					)
				},
			},

			{
				key: 'payments',

				label: (
					<div className='px-[16px] py-[12px] w-[150px] text-wrap'>
						Oxirgi to'lov qilingan sana
					</div>
				),

				getContent: ({ data }) => {
					const payments = data?.payments?.filter(
						item =>
							moment(item?.date, 'YYYY-MM-DD').format('MM') ===
							month
					)

					const date =
						payments?.length > 0
							? prettyDate(
									payments[payments?.length - 1]?.date
								)
							: '-'

					return (
						<div className='text-start px-[16px] py-[12px]'>
							{date}
						</div>
					)
				},
			},

			{
				key: 'payments',

				label: (
					<div className='px-[16px] py-[12px] w-[150px] text-wrap'>
						To'lov qilingan umumiy summa
					</div>
				),

				getContent: ({ data }) => {
					const payments = data?.payments?.filter(
						item =>
							moment(item?.date, 'YYYY-MM-DD').format('MM') ===
							month
					)

					const totalAmount = payments?.reduce(
						(sum, payment) =>
							sum + payment?.amount,
						0
					)

					return (
						<div className='text-start px-[16px] py-[12px]'>
							{prettyPrice(totalAmount) || '-'}
						</div>
					)
				},
			},

			{
				key: 'actions',

				label: (
					<div className='px-[16px] py-[12px]'>
						Amallar
					</div>
				),

				getContent: ({ data }) => {
					return (
						<div className='flex items-center px-[16px] py-[4px]'>
							<Payment
								data={data}
								getGroupById={getGroupById}
							/>

							<PreviewPayment
								data={data}
								getGroupById={getGroupById}
							/>

							{role === 'admin' && (
								<DeleteStudent
									data={data}
									getGroupById={getGroupById}
									month={month}
								/>
							)}
						</div>
					)
				},
			},
		]
	}, [month, visible, dataBaza, role])

	const headersTeacher = useMemo(() => {
		return [
			{
				key: 'order',

				label: (
					<div className='min-w-[20px] text-center sm:text-start px-[16px] py-[12px]'>
						№
					</div>
				),

				getContent: ({ index }) => {
					const order = index + 1

					return (
						<div className='text-center sm:text-start px-[16px] py-[12px]'>
							{order}
						</div>
					)
				},
			},

			{
				key: 'first_name',

				label: (
					<div className='px-[16px] py-[12px]'>
						Ism
					</div>
				),

				getContent: ({ data }) => {
					const name = data?.first_name

					return (
						<div className='text-start px-[16px] py-[12px]'>
							{name}
						</div>
					)
				},
			},

			{
				key: 'last_name',

				label: (
					<div className='px-[16px] py-[12px]'>
						Familiya
					</div>
				),

				getContent: ({ data }) => {
					const name = data?.last_name

					return (
						<div className='text-start px-[16px] py-[12px]'>
							{name}
						</div>
					)
				},
			},

			{
				key: 'phone_number',

				label: (
					<div className='px-[16px] py-[12px]'>
						Otasining telefon raqami
					</div>
				),

				getContent: ({ data }) => {
					const phone = data?.phone_number || '-'

					return (
						<div className='text-start px-[16px] py-[12px]'>
							{phone}
						</div>
					)
				},
			},

			{
				key: 'phone_number2',

				label: (
					<div className='px-[16px] py-[12px]'>
						Onasining telefon raqami
					</div>
				),

				getContent: ({ data }) => {
					const phone = data?.phone_number2 || '-'

					return (
						<div className='text-start px-[16px] py-[12px]'>
							{phone}
						</div>
					)
				},
			},

			{
				key: 'payments',

				label: (
					<div className='px-[16px] py-[12px] w-[150px] text-wrap'>
						Oxirgi to'lov qilingan sana
					</div>
				),

				getContent: ({ data }) => {
					const payments = data?.payments?.filter(
						item =>
							moment(item?.date, 'YYYY-MM-DD').format('MM') ===
							month
					)

					const date =
						payments?.length > 0
							? prettyDate(
									payments[payments?.length - 1]?.date
								)
							: '-'

					return (
						<div className='text-start px-[16px] py-[12px]'>
							{date}
						</div>
					)
				},
			},

			{
				key: 'payments',

				label: (
					<div className='px-[16px] py-[12px] w-[150px] text-wrap'>
						To'lov qilingan umumiy summa
					</div>
				),

				getContent: ({ data }) => {
					const payments = data?.payments?.filter(
						item =>
							moment(item?.date, 'YYYY-MM-DD').format('MM') ===
							month
					)

					const totalAmount = payments?.reduce(
						(sum, payment) =>
							sum + payment?.amount,
						0
					)

					return (
						<div className='text-start px-[16px] py-[12px]'>
							{prettyPrice(totalAmount) || '-'}
						</div>
					)
				},
			},
		]
	}, [month, visible, dataBaza])

	const headersStudent = useMemo(() => {
		return [
			{
				key: 'order',

				label: (
					<div className='min-w-[20px] text-center sm:text-start px-[16px] py-[12px]'>
						№
					</div>
				),

				getContent: ({ index }) => {
					const order = index + 1

					return (
						<div className='text-center sm:text-start px-[16px] py-[12px]'>
							{order}
						</div>
					)
				},
			},

			{
				key: 'first_name',

				label: (
					<div className='px-[16px] py-[12px]'>
						Ism
					</div>
				),

				getContent: ({ data }) => {
					const name = data?.first_name

					return (
						<div className='text-start px-[16px] py-[12px]'>
							{name}
						</div>
					)
				},
			},

			{
				key: 'last_name',

				label: (
					<div className='px-[16px] py-[12px]'>
						Familiya
					</div>
				),

				getContent: ({ data }) => {
					const name = data?.last_name

					return (
						<div className='text-start px-[16px] py-[12px]'>
							{name}
						</div>
					)
				},
			},
		]
	}, [month, visible, dataBaza])

	const handleSelectAll = () => {
		const selectedAll = studentsDataBaza.map(
			item => item.id
		)

		if (
			updateDataBaza?.students?.length ===
			studentsDataBaza?.length
		) {
			setUpdateDataBaza({
				...updateDataBaza,
				students: [],
			})
		} else {
			setUpdateDataBaza({
				...updateDataBaza,
				students: selectedAll,
			})
		}
	}

	const handleSelect = studentId => {
		if (
			updateDataBaza?.students?.includes(studentId)
		) {
			setUpdateDataBaza({
				...updateDataBaza,

				students:
					updateDataBaza?.students?.filter(
						item => item !== studentId
					),
			})
		} else {
			const newStudentsList = [
				...(updateDataBaza?.students || []),
				studentId,
			]

			setUpdateDataBaza({
				...updateDataBaza,
				students: newStudentsList,
			})
		}
	}

	const headersModal = [
		{
			key: 'checkbox',

			label: (
				<CheckboxInput
					type='checkbox'
					value={
						updateDataBaza?.students?.length ===
						studentsDataBaza?.length
					}
					onChange={handleSelectAll}
					className='w-4 h-4'
				/>
			),

			width: '50px',

			getContent: ({ data }) => (
				<CheckboxInput
					type='checkbox'
					value={updateDataBaza?.students?.some(
						item => item === data.id
					)}
					onChange={() => handleSelect(data?.id)}
					className='w-4 h-4'
				/>
			),
		},

		{
			key: 'first_name',
			label: 'Ism',

			getContent: ({ data }) => {
				const name = data?.first_name

				return (
					<div className='text-start'>
						{name}
					</div>
				)
			},
		},

		{
			key: 'last_name',
			label: 'Familiya',

			getContent: ({ data }) => {
				const name = data?.last_name

				return (
					<div className='text-start'>
						{name}
					</div>
				)
			},
		},

		{
			key: 'student_class',
			label: 'Sinf',

			getContent: ({ data }) => {
				const name =
					data?.student_class || '-'

				return (
					<div className='text-start'>
						{name}
					</div>
				)
			},
		},

		{
			key: 'phone_number',
			label: 'Otasining telefon raqami',

			getContent: ({ data }) => {
				const phone =
					data?.phone_number || '-'

				return (
					<div className='text-start'>
						{phone}
					</div>
				)
			},
		},

		{
			key: 'phone_number2',
			label: 'Onasining telefon raqami',

			getContent: ({ data }) => {
				const phone =
					data?.phone_number2 || '-'

				return (
					<div className='text-start'>
						{phone}
					</div>
				)
			},
		},
	]

	const headersColorModal = [
		{
			key: 'first_name',
			label: 'Ism',

			getContent: ({ data }) => {
				const user =
					dataBaza?.students?.find(
						item =>
							item?.id === data?.student
					)

				return (
					<div className='text-start'>
						{user?.last_name +
							' ' +
							user?.first_name || '--'}
					</div>
				)
			},
		},

		{
			key: 'student_class',
			label: 'Sinf',

			getContent: ({ data }) => {
				const user =
					dataBaza?.students?.find(
						item =>
							item?.id === data?.student
					)

				return (
					<div className='text-start'>
						{user?.student_class || '--'}
					</div>
				)
			},
		},

		{
			key: 'lesson',
			label: 'Dars',

			getContent: ({ data }) => {
				const lesson =
					dataBaza?.lessons?.find(
						item =>
							item?.id === data?.lesson
					)

				return (
					<div className='text-start'>
						{lesson?.name || '--'}
					</div>
				)
			},
		},

		{
			key: 'point',
			label: 'Baho',

			getContent: ({ data }) => {
				const point =
					data?.point || '0'

				return (
					<div className='text-start'>
						{point}
					</div>
				)
			},
		},

		{
			key: 'max_point',
			label: 'Maks.baho',

			getContent: ({ data }) => {
				const lesson =
					dataBaza?.lessons?.find(
						item =>
							item?.id === data?.lesson
					)

				return (
					<div className='text-start'>
						{lesson?.max_point || '--'}
					</div>
				)
			},
		},

		{
			key: 'color',
			label: 'Bahosi rangi',

			getContent: ({ data }) => {
				return (
					<Select
						isClearable={false}
						isSearchable={false}
						value={data?.color}
						options={colorList}
						onChange={color => {
							const filterBaza =
								colorDataBaza?.filter(
									item =>
										item?.student !==
										data?.student
								)

							setColorDataBaza([
								...filterBaza,
								{
									...data,
									color,
								},
							])
						}}
					/>
				)
			},
		},
	]

	const paymentsHeader = [
		{
			key: 'date',
			label: "To'lov sanasi",

			getContent: ({ data }) => {
				const date = data?.date
					? prettyDate(data?.date)
					: '-'

				return (
					<div className='text-start'>
						{date}
					</div>
				)
			},
		},

		{
			key: 'amount',
			label: "To'lov summasi",

			getContent: ({ data }) => {
				const amount = data?.amount
					? prettyPrice(data?.amount)
					: '-'

				return (
					<div className='text-start'>
						{amount}
					</div>
				)
			},
		},
	]

	const getStudents = () => {
		const options = {
			filter: {
				page: 1,
				page_size: 10000,
				search,
			},

			onError: () =>
				setStudentsDataBaza([]),

			onSuccess: response => {
				setStudentsDataBaza(
					response?.data?.results
				)
			},
		}

		services.students.getStudents(options)
	}

	const getGroupById = () => {
		const options = {
			id,
			role,
			month,
			year,

			filter: {
				lesson_id: sort_field,
				sort_field: sort_order,
			},

			onEnd: () =>
				setLoading(false),

			onStart: () =>
				setLoading(true),

			onSuccess: response => {
				const students =
					response?.data?.students || []

				const lessons =
					response?.data?.lessons || []

				setDataBaza({
					...response?.data,

					students: students.map(
						item => ({
							...item,
							name:
								response?.data?.name,
						})
					),
				})

				setUpdateDataBaza({
					...response?.data,

					students: students.map(
						item => item.id
					),
				})

				/*
				 * Darslarni sana bo'yicha:
				 * eng yangi sana -> eng eski sana
				 *
				 * [...lessons] orqali original API
				 * array o'zgartirilmaydi.
				 */
				const newColumns = [
					...lessons,
				]
					.sort((a, b) => {
						const dateA = moment(
							a?.date,
							'YYYY-MM-DD'
						).valueOf()

						const dateB = moment(
							b?.date,
							'YYYY-MM-DD'
						).valueOf()

						return dateB - dateA
					})
					.map(item => ({
						key: `lesson_${item?.id}`,

						label: (
							<div
								className='cursor-pointer flex flex-col items-center justify-between'
								onClick={() =>
									onChangeFilter(
										item?.id
									)
								}
							>
								<div className='flex items-center justify-center sm:justify-between gap-4 relative px-[16px] py-[12px]'>
									<div className='flex flex-col'>
										<span className='text-[14px] text-center w-full sm:w-auto sm:text-start'>
											{item?.name}
										</span>

										<span className='text-[12px]'>
											{prettyDate(
												item?.date
											)}
										</span>
									</div>

									<div className='flex flex-col items-center gap-3'>
										{role ===
											'teacher' && (
											<span
												className='text-red-500 cursor-pointer'
												onClick={e => {
													e.stopPropagation()

													setVisibleDelete(
														true
													)

													setDeleteLessonId(
														item?.id
													)
												}}
											>
												<Delete classname='size-5 sm:size-6' />
											</span>
										)}

										{sort_field ===
										item?.id
											? down
											: <UpDown />}
									</div>
								</div>
							</div>
						),

						getContent: ({ data }) => {
							const gradeObj =
								item?.grades?.find(
									child =>
										child?.student ===
										data?.id
								)

							const grade =
								gradeObj?.point

							const color =
								gradeObj?.color ===
								'orange'
									? '#018ecc'
									: gradeObj?.color !==
											'white'
										? gradeObj?.color
										: ''

							if (
								role ===
								'teacher'
							) {
								return (
									<NumberInputColor
										hideBorder={
											true
										}
										value={
											grade
										}
										color={
											color
										}
										onChange={value =>
											gradeStudent(
												data?.id,
												item?.id,
												Number(
													value
												),
												gradeObj?.point,
												gradeObj?.id,
												item?.max_point
											)
										}
									/>
								)
							}

							return (
								<div
									className='px-[16px] py-[12px] text-center'
									style={{
										backgroundColor:
											color,
										color: color
											? '#ffffff'
											: '',
									}}
								>
									{grade}
								</div>
							)
						},
					}))

				/*
				 * Role bo'yicha kerakli
				 * static columns + sorted lessons.
				 */
				if (
					role === 'admin' ||
					role === 'accountant'
				) {
					setMixedColumns([
						...headersAdmin,
						...newColumns,
					])
				} else if (
					role === 'student'
				) {
					setMixedColumns([
						...headersStudent,
						...newColumns,
					])
				} else {
					setMixedColumns([
						...headersTeacher,
						...newColumns,
					])
				}
			},
		}

		services.groups.getGroupById(
			options
		)
	}

	useEffect(() => {
		getGroupById()
	}, [month, year, filter])

	useEffect(() => {
		if (
			role === 'admin' ||
			role === 'accountant'
		) {
			getStudents()
		}
	}, [search, month, year])

	return (
		<div className='sm:p-6 p-3'>
			<Head />

			<Header role={role} />

			<InfoCard
				{...dataBaza}
				role={role}
				loading={loading}
			/>

			<div className='mt-4 sm:hidden grid grid-cols-2 gap-4'>
				<div className='col-span-1'>
					<Select
						isClearable={false}
						isSearchable={false}
						size='small'
						isDisabled={
							yearList.filter(
								item =>
									Number(
										item?.value
									) >= 2025
							)?.length < 2
						}
						options={yearList.filter(
							item =>
								Number(
									item?.value
								) >= 2025
						)}
						value={yearList?.find(
							item =>
								item.value ===
								year
						)}
						onChange={({
							value,
						}) =>
							setYear(value)
						}
					/>
				</div>

				<div className='col-span-1'>
					<Select
						isClearable={false}
						size='small'
						options={monthList}
						value={monthList?.find(
							item =>
								item.value ===
								month
						)}
						onChange={({
							value,
						}) =>
							setMonth(value)
						}
					/>
				</div>
			</div>

			{role === 'student' ? (
				<Fragment>
					<div className='flex items-center justify-between my-4'>
						<h2 className='text-[16px] lg:text-[22px] text-[#292A32] dark:text-[#ffffff] font-semibold'>
							To'lovlar
						</h2>
					</div>

					<Table
						isLoading={loading}
						data={dataBaza?.payments}
						headers={paymentsHeader}
					/>
				</Fragment>
			) : (
				<></>
			)}

			<div className='flex items-center justify-between my-4'>
				<h2 className='text-[16px] lg:text-[22px] text-[#292A32] dark:text-[#ffffff] font-semibold'>
					O'quvchilar
				</h2>

				<div className='flex items-center gap-3'>
					<div className='hidden sm:inline w-[100px] sm:w-[150px]'>
						<Select
							isClearable={false}
							isSearchable={false}
							size='small'
							isDisabled={
								yearList.filter(
									item =>
										Number(
											item?.value
										) >=
										2025
								)?.length < 2
							}
							options={yearList.filter(
								item =>
									Number(
										item?.value
									) >= 2025
							)}
							value={yearList?.find(
								item =>
									item.value ===
									year
							)}
							onChange={({
								value,
							}) =>
								setYear(
									value
								)
							}
						/>
					</div>

					<div className='w-[200px] hidden sm:inline'>
						<Select
							isClearable={false}
							isSearchable={false}
							size='small'
							options={monthList}
							value={monthList?.find(
								item =>
									item.value ===
									month
							)}
							onChange={({
								value,
							}) =>
								setMonth(
									value
								)
							}
						/>
					</div>

					{role === 'teacher' && (
						<button
							className='success-btn'
							onClick={() =>
								setVisibleLesson(
									true
								)
							}
						>
							Dars qo'shish
						</button>
					)}

					{role === 'admin' && (
						<button
							className='success-btn'
							onClick={() =>
								setVisible(true)
							}
						>
							O'quvchi qo'shish
						</button>
					)}
				</div>
			</div>

			<div className='mb-4 h-[70vh]'>
				<Table
					isLoading={loading}
					data={dataBaza?.students}
					headers={mixedColumns}
					withPadding={false}
					stickyColumnCount={3}
				/>
			</div>

			<span className='text-red-500 text-[14px]'>
				" -1 " - O'quvchi darsga
				kelmaganligini bildiradi.
			</span>

			{bulkGrades?.length ? (
				<div className='flex justify-end mt-3'>
					<div
						className='success-btn'
						onClick={selectedColors}
					>
						Rang biriktirish va saqlash
					</div>
				</div>
			) : (
				<></>
			)}

			{/* Rang qo'shish */}
			<Modal
				onClose={() =>
					setColorModal(false)
				}
				onOpen={() =>
					setColorModal(true)
				}
				open={colorModal}
			>
				<div className='p-6'>
					<div className='flex flex-col sm:flex-row sm:items-center justify-between gap-2 mb-4'>
						<h1 className='text-[18px] lg:text-[24px] text-[#292A32] dark:text-[#ffffff] font-semibold'>
							Baholarga rang qo'shish
						</h1>
					</div>

					<div className='mb-4 max-h-96 overflow-y-auto'>
						<Table
							data={colorDataBaza?.sort(
								(a, b) =>
									a.student -
									b.student
							)}
							headers={
								headersColorModal
							}
							isLoading={false}
							emptyMessage="Ma'lumot topilmadi"
							withPadding={true}
						/>
					</div>

					<div className='flex justify-end items-center mt-[24px]'>
						<button
							disabled={disabled}
							className='success-btn w-full sm:w-[150px]'
							onClick={
								bulkGradesSave
							}
						>
							Saqlash
						</button>
					</div>
				</div>
			</Modal>

			{/* O'quvchi qo'shish */}
			<Modal
				onClose={() =>
					setVisible(false)
				}
				onOpen={() =>
					setVisible(true)
				}
				open={visible}
			>
				<div className='p-6'>
					<div className='flex flex-col sm:flex-row sm:items-center justify-between gap-2 mb-4'>
						<h1 className='text-[18px] lg:text-[24px] text-[#292A32] dark:text-[#ffffff] font-semibold'>
							O'quvchi qo'shish
						</h1>

						<div className='max-w-full sm:max-w-[300px] sm:pe-4'>
							<TextInput
								size='small'
								placeholder='Izlash...'
								value={
									search
								}
								onChange={value =>
									setSearch(
										value
									)
								}
							/>
						</div>
					</div>

					<div className='mb-4 max-h-96 overflow-y-auto'>
						<Table
							data={
								studentsDataBaza
							}
							headers={
								headersModal
							}
							isLoading={false}
							emptyMessage="Ma'lumot topilmadi"
							withPadding={true}
						/>
					</div>

					<div className='flex justify-end items-center mt-[24px]'>
						<button
							disabled={disabled}
							className='success-btn w-full sm:w-[150px]'
							onClick={
								uploadStudentInfo
							}
						>
							Saqlash
						</button>
					</div>
				</div>
			</Modal>

			{/* Dars qo'shish */}
			<Modal
				onClose={() =>
					setVisibleLesson(false)
				}
				onOpen={() =>
					setVisibleLesson(true)
				}
				open={visibleLesson}
			>
				<div className='p-6'>
					<h1 className='text-[18px] lg:text-[24px] text-[#292A32] dark:text-[#ffffff] font-semibold mb-4'>
						Yangi dars qo'shish
					</h1>

					<div className='mb-4 grid grid-cols-12 gap-4'>
						<div className='col-span-12 sm:col-span-6'>
							<Label>
								Dars nomi
							</Label>

							<TextInput
								value={
									lessonForm?.name
								}
								onChange={name =>
									setLessonForm(
										{
											...lessonForm,
											name,
										}
									)
								}
							/>
						</div>

						<div className='col-span-12 sm:col-span-6'>
							<Label>
								Dars sanasi
							</Label>

							<DateInput
								value={
									lessonForm?.date
								}
								onChange={date =>
									setLessonForm(
										{
											...lessonForm,
											date,
										}
									)
								}
							/>
						</div>

						<div className='col-span-12 sm:col-span-6'>
							<Label>
								Maksimal baho
							</Label>

							<NumberInput
								value={
									lessonForm?.max_point
								}
								onChange={max_point =>
									setLessonForm(
										{
											...lessonForm,
											max_point,
										}
									)
								}
							/>
						</div>

						<div className='col-span-12 sm:col-span-6'>
							<Label>
								Guruh
							</Label>

							<TextInput
								isDisabled
								value={
									dataBaza?.name
								}
							/>
						</div>
					</div>

					<div className='flex justify-end items-center mt-[24px]'>
						<button
							disabled={
								disabledLesson
							}
							className='success-btn w-full sm:w-[150px]'
							onClick={
								createLesson
							}
						>
							Yaratish
						</button>
					</div>
				</div>
			</Modal>

			{/* Darsni o'chirish */}
			<Modal
				onClose={() =>
					setVisibleDelete(false)
				}
				onOpen={() =>
					setVisibleDelete(true)
				}
				open={visibleDelete}
			>
				{loading ? (
					<div className='w-[450px] h-[227px] flex items-center justify-center'>
						<Spinner />
					</div>
				) : (
					<div className='py-[32px] px-[24px]'>
						<h4 className='text-[#292B32] dark:text-[#f2f2f2] text-[24px] font-bold m-0 text-center'>
							Darsni o‘chirish
						</h4>

						<p className='text-[#292B32] dark:text-[#f2f2f2] text-lg font-medium mx-0 mt-[16px] mb-[0] text-center'>
							Haqiqatan ham ushbu darsni o‘chirmoqchimisiz?
						</p>

						<div className='flex justify-center items-center mt-[24px]'>
							<button
								className='mute-btn mr-5 min-w-[150px]'
								onClick={() =>
									setVisibleDelete(
										false
									)
								}
							>
								Bekor qilish
							</button>

							<button
								className='danger-btn min-w-[150px]'
								onClick={() =>
									deleteLesson(
										deleteLessonId
									)
								}
							>
								Ha
							</button>
						</div>
					</div>
				)}
			</Modal>
		</div>
	)
}

export default DetailGroup